module.exports = __webpack_public_path__ + "img/no-card.f2703777.svg";